import { defineComponent as _defineComponent } from 'vue'
import Tabs from "../components/tabs.vue"
import Tab from "../components/tab.vue"
import UpcomingMeeting from "../components/upcomingMeeting.vue"
import Loader from '@/components/loader.vue';
import { ref, computed, onBeforeMount } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { Meetings } from '@busy-human/opt-library';
import meetingPopup from "@/components/meeting-details/meeting-details.vue"
import { DataInstance } from "@busy-human/gearbox";
import { useUserspace } from "@/store/userspace";
import { useMeetings } from "@/store/meetings";

enum RequestStage{
    MEETINGS = 0,
    POPUP = 1,
}
type meetingsByMonth = {
    month: string,
    meetings: Meetings.Model[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'meetings',
  setup(__props, { expose }) {
  expose();
 // Please use <script setup lang="ts">
const tabIndex = ref(0)
const route = useRoute();
const selectedMeeting = ref<DataInstance<Meetings.Model> | null>(null);
const stage = ref(RequestStage.MEETINGS)
const noScheduledMeetings = ref(false)
const noHeldMeetings = ref(false)

const userspace = useUserspace();
const user = computed(() => userspace.user);

if(route.hash == "#held"){
    tabIndex.value = 1
}

const loading = ref(false)

const allMeetings = computed<DataInstance<Meetings.Model>[]>(() => useMeetings().list);

const meetingsByMonth = computed<meetingsByMonth[]>(()=>{
    let meetingsByMonth: meetingsByMonth[] = [];
    allMeetings.value.forEach(meeting =>{
        if( meeting.status === Meetings.MeetingStatus.scheduled || 
            meeting.status === Meetings.MeetingStatus.meetingStarted || 
            meeting.status === Meetings.MeetingStatus.meetingEnded || 
            (meeting.status === Meetings.MeetingStatus.collectorConfirmed && meeting?.payer == userspace.uid) || 
            (meeting.status === Meetings.MeetingStatus.payerConfirmed && meeting?.collector == userspace.uid)){

            let monthOfMeeting = getMonthFromMeeting(meeting)
            if(!monthIncluded(meetingsByMonth, monthOfMeeting)){
                const newMonthObject:meetingsByMonth = {
                    month: monthOfMeeting,
                    meetings: []
                }
                newMonthObject.meetings.push(meeting)
                meetingsByMonth.push(newMonthObject)
            }else{
                let monthObject = meetingsByMonth.filter((monthObj) => monthObj.month === monthOfMeeting)[0]
                monthObject.meetings.push(meeting)
            }
        }
    })

    if(meetingsByMonth.length === 0)
        noScheduledMeetings.value = true

    sortMeetingsByMonth(meetingsByMonth)

    return meetingsByMonth
})

const heldMeetingsByMonth = computed<meetingsByMonth[]>(()=>{
    let heldMeetingsByMonth: meetingsByMonth[] = [];
    allMeetings.value.forEach(meeting =>{
        if((meeting.status === Meetings.MeetingStatus.collectorConfirmed && meeting?.collector == userspace.uid) || 
            (meeting.status === Meetings.MeetingStatus.payerConfirmed && meeting?.payer == userspace.uid) ||
            meeting.status === Meetings.MeetingStatus.fullyConfirmed ||
            meeting.status === Meetings.MeetingStatus.adminConfirmed ||
            meeting.status === Meetings.MeetingStatus.contested ){

            let monthOfMeeting = getMonthFromMeeting(meeting)
            if(!monthIncluded(heldMeetingsByMonth, monthOfMeeting)){
                const newMonthObject:meetingsByMonth = {
                    month: monthOfMeeting,
                    meetings: []
                }
                newMonthObject.meetings.push(meeting)
                heldMeetingsByMonth.push(newMonthObject)
            }else{
                let monthObject = heldMeetingsByMonth.filter((monthObj) => monthObj.month === monthOfMeeting)[0]
                monthObject.meetings.push(meeting)
            }
        }
    })

    if(heldMeetingsByMonth.length === 0)
        noHeldMeetings.value = true
    sortMeetingsByMonth(heldMeetingsByMonth)

    return heldMeetingsByMonth
})

const router = useRouter();

const routeTo = (route: string) =>{
    router.push(`/${route}`)
}
const handlePopup = (value: DataInstance<Meetings.Model>) =>{
    selectedMeeting.value = value
    stage.value = RequestStage.POPUP
}

const closePopup = ()=>{
    stage.value = RequestStage.MEETINGS
}

const getScheduledMeetingLen = computed(()=>{
    let counter = 0;
    for(let i = 0; i < meetingsByMonth.value.length; i++){
        counter += meetingsByMonth.value[i].meetings.length
    }
    return counter
})

const getHeldMeetingLen = computed(()=>{
    let counter = 0;
    for(let i = 0; i < heldMeetingsByMonth.value.length; i++){
        counter += heldMeetingsByMonth.value[i].meetings.length
    }
    return counter;
})

const getMonthFromMeeting = (meeting:DataInstance<Meetings.Model>):string => {
    const dateOptions: Intl.DateTimeFormatOptions = {month: 'long'}
    let start = new Date(meeting.startTime)
    let month = new Intl.DateTimeFormat('en-US', dateOptions).format(start) || ''
    return month
}

const monthIncluded = (meetingsByMonthArray: meetingsByMonth[], month: string):boolean => {
    let matchingMonth = meetingsByMonthArray.filter((monthObj) => monthObj.month === month)
    if(matchingMonth.length > 0)
        return true

    return false
}

const sortMeetingsByMonth = (meetingsByMonthArray: meetingsByMonth[]) => {
    if(meetingsByMonthArray.length === 0) return
    for(let i = 0; i < meetingsByMonthArray.length; i++){
        meetingsByMonthArray[i].meetings.sort((a,b)=>{
            let startA = new Date(a.startTime)
            let startB = new Date(b.startTime)
            if(startA < startB){
                return -1
            }else if(startA > startB){
                return 1
            }else{
                return 0
            }
        })
    }
}



const __returned__ = { RequestStage, tabIndex, route, selectedMeeting, stage, noScheduledMeetings, noHeldMeetings, userspace, user, loading, allMeetings, meetingsByMonth, heldMeetingsByMonth, router, routeTo, handlePopup, closePopup, getScheduledMeetingLen, getHeldMeetingLen, getMonthFromMeeting, monthIncluded, sortMeetingsByMonth, Tabs, Tab, UpcomingMeeting, Loader, ref, computed, onBeforeMount, useRoute, useRouter, Meetings, meetingPopup, DataInstance, useUserspace, useMeetings }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})